import { LearnerProfileMock } from './types';

export const mockLearnerProfile: LearnerProfileMock = {
  id: 'usr_forge_0842',
  name: 'Alex Mercer',
  role: 'Tier 2 Escalations Agent',
  accountTrack: 'Telecom Inbound Care & Retention',
  readinessScore: 78,
  pillarScores: {
    communication: 82,
    support: 74,
    sales: 79,
  },
  confidence: {
    level: 'High',
    percentage: 88,
    sampleSize: 42,
  },
  freshness: {
    freshSkillsCount: 18,
    staleSkillsCount: 3,
    lastPracticed: 'Today, 09:15 AM',
  },
  storageHealth: {
    status: 'optimal',
    usedBytes: 14.2 * 1024 * 1024, // 14.2 MB
    totalBytes: 500 * 1024 * 1024, // 500 MB
    percentage: 3,
  },
  syncStatus: 'synced',
};
